var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"v-select-review mt-2",attrs:{"value":_vm.period.value,"attach":true,"menu-props":{
    contentClass: 'select-review-menu',
    offsetY: true
  },"items":_vm.period.items,"dense":"","hide-details":""},on:{"change":function($event){return _vm.setPeriod($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }